import React, { useEffect } from 'react';
import { EntityStoreProvider } from 'containers/pages/persons/store/EntityStoreContext';
import PersonCard from 'containers/partials/cards/PersonCard';
import { generatePath, useParams, useHistory } from 'react-router-dom';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import {
  ROUTE_SESSIONS_ENTITY_SESSION_PERSON_GLOBAL,
  ROUTE_SESSIONS_ENTITY_SESSION_PERSONS
} from 'routes/RouteList';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'Can';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import RemoveSporterFromSessionButton from 'containers/partials/buttons/RemoveSporterFromSessionButton';
import { useSessionContext } from 'contexts/SessionContext';
import messages from 'messages';
import slugify from 'slugify';

const SessionPersonGlobalTab = () => {
  const { entityId, sessionsTab, sessionId, personId, groupId } = useParams();
  const person = useEntityContext(s => s.person);
  const { session } = useSessionContext();
  const { push } = useHistory();
  const ability = useAbility(AbilityContext);
  const { setMenuItems, clearAllContext } = useContextMenu();

  useEffect(() => {
    const contextButtons = [];

    if (ability.can('manage', 'Sessions')) {
      contextButtons.push(
        <RemoveSporterFromSessionButton
          menu
          rootEntityId={entityId}
          sessionId={session.id}
          ids={[personId]}
          onComplete={() =>
            push(
              generatePath(ROUTE_SESSIONS_ENTITY_SESSION_PERSONS, {
                entityId,
                sessionsTab,
                sessionId: session.id
              })
            )
          }
          dataQa={`${slugify(messages.menuItemSessionRemoveSporter.id.toLowerCase())}-menu`}
        />
      );
    }

    setMenuItems(contextButtons);

    return () => {
      // Cleanup action buttons and context menu items
      clearAllContext();
    };
  }, [person, ability, groupId, sessionId]);

  const onCancel = () => {
    push(
      generatePath(ROUTE_SESSIONS_ENTITY_SESSION_PERSON_GLOBAL, {
        sessionId,
        sessionsTab,
        entityId,
        personId
      })
    );
  };

  return (
    <EntityStoreProvider>
      <PersonCard entityId={entityId} person={person} onCancel={onCancel} />
    </EntityStoreProvider>
  );
};

export default SessionPersonGlobalTab;
